// Test view component for displaying a single test

import { TestViewProps } from '../types';

export function TestView(props: TestViewProps, container: HTMLElement): void {
  const { test, error, logs, showConsoleLogs, expanded } = props;
  
  // Create unique IDs for this test
  const testDetailsId = `test-details-${test.id}`;
  
  // Format duration
  const formatDuration = (ms: number): string => {
    if (ms < 1) return '<1ms';
    if (ms < 1000) return `${ms}ms`;
    return `${(ms / 1000).toFixed(2)}s`;
  };
  
  // Determine test icon and class
  const testClass = test.status === 'passed' ? 'msdr-test-passed' : 'msdr-test-failed';
  const testIcon = test.status === 'passed' ? '✓' : '✗';
  const testIconClass = test.status === 'passed' ? 'passed' : 'failed';
  
  // Create test container
  const testDiv = document.createElement('div');
  testDiv.className = `msdr-test ${testClass}`;
  
  // Create test header
  const testHeader = document.createElement('div');
  testHeader.className = 'msdr-test-header';
  testHeader.addEventListener('click', () => toggleTest());
  
  const testIconEl = document.createElement('span');
  testIconEl.className = `msdr-test-icon ${testIconClass}`;
  testIconEl.textContent = testIcon;
  
  const testTitle = document.createElement('span');
  testTitle.className = 'msdr-test-title';
  testTitle.textContent = test.title;
  
  const testDuration = document.createElement('span');
  testDuration.className = 'msdr-test-duration';
  testDuration.textContent = formatDuration(test.duration);
  
  testHeader.appendChild(testIconEl);
  testHeader.appendChild(testTitle);
  testHeader.appendChild(testDuration);
  
  // Create test details
  const testDetails = document.createElement('div');
  testDetails.id = testDetailsId;
  testDetails.className = `msdr-test-details ${expanded ? 'expanded' : ''}`;
  
  // Add error details if test failed
  if (error) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'msdr-error';
    
    const errorMessage = document.createElement('div');
    errorMessage.className = 'msdr-error-message';
    errorMessage.textContent = error.message;
    
    const errorStack = document.createElement('div');
    errorStack.className = 'msdr-error-stack';
    errorStack.textContent = error.stack;
    
    errorDiv.appendChild(errorMessage);
    errorDiv.appendChild(errorStack);
    testDetails.appendChild(errorDiv);
  }
  
  // Add logs if available and enabled
  if (logs && logs.length > 0 && showConsoleLogs) {
    const logsDiv = document.createElement('div');
    logsDiv.className = 'msdr-logs';
    
    const logsHeader = document.createElement('div');
    logsHeader.className = 'msdr-logs-header';
    logsHeader.textContent = 'Console Output';
    logsDiv.appendChild(logsHeader);
    
    logs.forEach(log => {
      const logItem = document.createElement('div');
      logItem.className = `msdr-log-item log-${log.type}`;
      
      const logTimestamp = document.createElement('span');
      logTimestamp.className = 'msdr-log-timestamp';
      logTimestamp.textContent = new Date(log.timestamp).toISOString().split('T')[1].slice(0, -1);
      
      const logContent = document.createElement('span');
      logContent.textContent = log.content;
      
      logItem.appendChild(logTimestamp);
      logItem.appendChild(logContent);
      logsDiv.appendChild(logItem);
    });
    
    testDetails.appendChild(logsDiv);
  }
  
  // Handle test toggle
  function toggleTest() {
    const details = document.getElementById(testDetailsId);
    if (details) {
      details.classList.toggle('expanded');
    }
  }
  
  testDiv.appendChild(testHeader);
  testDiv.appendChild(testDetails);
  container.appendChild(testDiv);
}
